import { lazy, useEffect } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import { Footer, Sidebar } from "Components";
import { TopBgSvg } from "images";

import "./App.scss";
import PanelColor from "./Components/theme/PanelColor";

const Home = lazy(() => import("./pages/home/container"));
const Services = lazy(() => import("./pages/services/container"));
const Portfolio = lazy(() => import("./pages/portfolio/container"));
const About = lazy(() => import("./pages/about/container"));
const Contact = lazy(() => import("./pages/contact/container"));

const App = () => {
  const location = useLocation();

  const onScroll = (e) => {
    if (e.target.documentElement.scrollTop > 50) {
      document.getElementsByTagName("nav")[0].classList.add("f_top");
    } else {
      document.getElementsByTagName("nav")[0].classList.remove("f_top");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [location]);

  return (
    <div className="app">
      <Sidebar />
      <Switch>
        <Route path="/home" component={Home} />
        <Route path="/services" component={Services} />
        <Route path="/portfolio" component={Portfolio} />
        <Route path="/about" component={About} />
        <Route path="/contact" component={Contact} />
        <Redirect to="/home" />
      </Switch>
      <PanelColor />
      <Footer />
      <TopBgSvg />
    </div>
  );
};

export default App;
